exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card {\n  cursor: pointer;\n  height: 300px;\n  margin: auto;\n}\n.card .panel-body {\n  margin-top: 10%;\n}\n.card .bjs-powered-by {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./App/Components/DiagramViewer/modules/Card.less
// module id = 300
// module chunks = 0